import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import useFinchStatus from 'components/Common/Members/Hooks/useFinchStatus';
import Pending from './Pending';
import Import from './Import';

export default function Index() {
  const navigate = useNavigate();
  const { loading: loadingFinchStatus, status: finchStatus } = useFinchStatus();

  useEffect(() => {
    if (!loadingFinchStatus && finchStatus.status === 'not_connected') {
      navigate(routes.managers.members.hrSystem.index);
    }
  }, [loadingFinchStatus]);

  if (!loadingFinchStatus) {
    if (finchStatus.status === 'connected') {
      return <Import />;
    }

    return <Pending status={finchStatus} />;
  }

  return (
    <div className="content">
      <section>
        <LoadingPlaceholder className="my-5" />
      </section>
    </div>
  );
}
